import React, { ReactElement } from "react";

interface advisoryText {
  type: string;
  label: string | ReactElement;
  Body?: React.FC;
  styleClasses?: string;
}

export function AdvisoryText({ type, label, Body, styleClasses, ...rest }: advisoryText) {
  return (
    <>
      <div className={" mr-5 text-left " + type + " " + styleClasses}>{Body ? <Body {...rest} /> : label}</div>
    </>
  );
}
